<template>
  <div ref="root" class="sp-card-actions" :class="classModifiers">
    <slot />
  </div>
</template>

<script setup>
import { computed, useTemplateRef } from "vue";
import { hasSlotContentDeep } from "#ce/utils/slots";

const root = useTemplateRef("root");

const hasActionsSlot = computed(() => hasSlotContentDeep(root.value));

const classModifiers = computed(() => ({
  "--has-actions-slot": hasActionsSlot.value,
}));
</script>

<style>
:host {
  display: block;
}
</style>

<style lang="scss" scoped>
.sp-card-actions {
  &.--has-actions-slot {
    display: flex;
    justify-content: var(--sp-comp-card-actions-justify-content, flex-start);
    padding-inline: var(--sp-card-actions-padding-inline, var(--sp-comp-card-padding-inline, 1rem));
    padding-block: var(--sp-card-actions-padding-block, var(--sp-comp-card-padding-block, 0.5rem));
    border-block-start: var(--sp-comp-card-actions-border-top, none);
  }
}
</style>
